var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CoingeckoProvider } from '../contexts/coingecko';
import { ConnectionProvider } from '../contexts/ConnectionContext';
import { LoaderProvider } from '../components/Loader';
import { SPLTokenListProvider } from '../contexts/tokenList';
import { WalletProvider } from '../contexts/WalletContext';
import { AppLayout } from './Layout';
import { Claim } from './Claim';
export var App = function () {
    var muiDarkTheme = createTheme({
        palette: {
            mode: 'dark',
            primary: {
                main: '#d0bdf4',
            },
            secondary: {
                main: '#8458B3',
            },
        },
    });
    return (_jsx(ThemeProvider, __assign({ theme: muiDarkTheme }, { children: _jsx(BrowserRouter, { children: _jsx(ConnectionProvider, { children: _jsx(SPLTokenListProvider, { children: _jsx(CoingeckoProvider, { children: _jsx(LoaderProvider, { children: _jsx(WalletProvider, { children: _jsx(AppLayout, { children: _jsx(Claim, {}) }) }) }) }) }) }) }) })));
};
export default App;
